import { storage, firestore } from "../plugins/firebase";
import { CollectionsNames, Fields } from "../definitions/constants";
import {
  Teammember,
  TeamMemberSort,
  TeamMemberSummarySort,
  Certificate,
  TeammemberWithSummaryDetails,
  LanguageSkill,
  ProfessionalDetail,
  Education,
  Phone,
  Address,
  TeammemberSkill,
  JobPreferencesModel,
} from "../models/Teammember";
import CareerHistories from "../models/CareerHistories";
import LineManager from "../models/LineManager";
import Commitment, { TeamMenberOfCommitment } from "../models/Commitment";
import { PersonalDetailModel } from "../models/PersonalDetailModel";
import RecaptchaResponse from "../models/RecaptchaResponse";
import { Contact } from "../models/Contact";
import ApiService from "./ApiService";
import CommitmentService from "../services/CommitmentService";
import { SystemErrors } from "../definitions/systemErrors";
import Utils from "../utils/Utils";

export default class TeamMemberService {
  public static getByProjectLeadId(projectLeadId: any): Promise<TeamMenberOfCommitment[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember/getTeammemberByProjectLead/${projectLeadId}`, "")
        .then((tmResult) => {
          if (!tmResult.data) {
            resolve([]);
          } else {
            const retVal = tmResult.data.map((d: any) => {
              const tm = { Id: d.id, ...d } as TeamMenberOfCommitment;
              return tm;
            });
            resolve(retVal);
          }
        })
        .catch((tmError) => reject("Team member error => " + tmError));
    });
  }

  public static async getLinemanagersByTeammemberId(teammemberId: any): Promise<LineManager[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember/lineManagers/admin/${teammemberId}`, "")
        .then((result) => {
          if (!result.data) {
            resolve([]);
          } else {
            const items = result.data.map((doc: any) => {
              const item = doc;
              const retVal = { ...item } as LineManager;
              return retVal;
            });
            resolve(items);
          }
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static create(model: Teammember, isSignUp = false): Promise<Teammember> {
    return new Promise((resolve, reject) => {
      const url = isSignUp ? "signup" : "create";
      ApiService.post(`/teammember/${url}`, model)
        .then((res: any) => {
          model.Id = res.data;
          resolve(model);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static removeResume(teammemberId = ""): Promise<boolean> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.delete(`${query.path}/teammember/removeCv${query.param}`)
        .then((res) => {
          if (!res.data) {
            resolve(false);
          } else {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async deleteCertificate(id: any, teammemberId = ""): Promise<Certificate[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.delete(`${query.path}/teammember/removeCertificate/${id}${query.param}`)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve([] as Certificate[]);
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async deleteLanguageSkill(id: any, teammemberId = ""): Promise<LanguageSkill[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.delete(`${query.path}/teammember/removeLanguageSkill/${id}${query.param}`)
        .then((res) => {
          if (!res.data) {
            resolve([] as LanguageSkill[]);
          } else {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getById(id: string): Promise<Teammember | null> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember/GetById/${id}`, "")
        .then((tmResult) => {
          if (tmResult.data) {
            resolve({ Id: tmResult.data.id, ...tmResult.data } as Teammember);
          } else {
            resolve(null);
          }
        })
        .catch((tmError) => reject(`error in TeamMemberService.getById -> ${tmError}`));
    });
  }

  public static getTeammember(uid: string | undefined): Promise<Teammember | null> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember/GetTeammemberByUid/${uid}`, "")
        .then((result) => {
          if (!result.data) {
            resolve(null);
          } else {
            resolve({ ...result.data } as Teammember);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static getTeammemberByEmail(email: string): Promise<Teammember | null> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember/GetTeammemberByEmail/${email}`, "")
        .then((result) => {
          if (!result.data) {
            resolve(null);
          } else {
            resolve({ ...result.data } as Teammember);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static uploadResume(file: File, teammemberId = ""): Promise<string> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.upload(`${query.path}/teammember/uploadProfileCv${query.param}`, file)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // public static getResumeDownloadLink(resumeLink: string): Promise<any> {
  //   return storage.ref().child(resumeLink).getDownloadURL();
  // }
  public static getResumeDownloadLink(teammemberEmail = ""): Promise<any> {
    return new Promise((resolve, reject) => {
      var path = "";
      var param = "";
      if (teammemberEmail) {
        param = `/${teammemberEmail}`;
        path = "/admin";
      }
      ApiService.get(`${path}/teammember/downloadProfileCv${param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getList(isAzure = false): Promise<Teammember[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember`, "")
        .then((tmResult) => {
          if (!tmResult.data) {
            resolve([]);
          } else {
            const retVal = tmResult.data.map((d: any) => {
              const tm = { Id: d.id, ...d } as Teammember;
              tm.FullName = `${tm.FirstName || ""} ${tm.LastName || ""}`;
              return tm;
            });
            resolve(retVal);
          }
        })
        .catch((tmError) => reject("Team member error => " + tmError));
    });
  }

  public static getListWithSummaryDetails(): Promise<TeammemberWithSummaryDetails[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/teammember/SummaryDetails`, "")
        .then((tmResult) => {
          if (!tmResult.data) {
            resolve([]);
          } else {
            const retVal = tmResult.data.map((d: any) => {
              const tm = { ...d } as TeammemberWithSummaryDetails;
              tm.FullName = `${tm.FirstName || ""} ${tm.LastName || ""}`;
              return tm;
            });
            resolve(retVal);
          }
        })
        .catch((tmError) => reject("Team member error => " + tmError));
    });
  }

  public static async getSortedList(): Promise<TeamMemberSort[]> {
    const teammemberSortList = [] as TeamMemberSort[];
    const commitmentList = await CommitmentService.getList();
    const theDate = new Date();
    const activecommitments = commitmentList.filter(
      (c) =>
        c.IsActive &&
        ((c.StartDate && c.StartDate <= theDate && c.EndDate && c.EndDate >= theDate) || (!c.StartDate && c.EndDate && c.EndDate >= theDate))
    );
    const inactiveCommitments = commitmentList.filter((c) => !c.IsActive || (c.EndDate && c.EndDate < theDate));

    const teamMembersAll = await this.getList(true);
    const teamMembers = teamMembersAll.filter((tm) => tm.FullName.trim());
    teamMembers.forEach((item) => {
      const isActive = activecommitments.some((c) => c.TeamMemberIds.includes(item.Id));
      if (isActive) {
        const tmItem = { ...item, isFirstInactive: false } as TeamMemberSort;
        teammemberSortList.push(tmItem);
      }
    });
    teamMembers.forEach((item: any) => {
      const isInActive = inactiveCommitments.some((c) => c.TeamMemberIds.includes(item.Id));
      const exist = teammemberSortList.some((c) => c.Id === item.Id);
      if (isInActive && !exist) {
        const tmItem = { ...item } as TeamMemberSort;
        const firstInactive = teammemberSortList.some((c) => c.isFirstInactive);
        if (!firstInactive) {
          tmItem.isFirstInactive = true;
        }
        teammemberSortList.push(tmItem);
      }
    });

    return teammemberSortList;
  }

  public static async getSortedSummaryList(): Promise<TeamMemberSummarySort[]> {
    const teammemberSortList = [] as TeamMemberSummarySort[];
    const teamMembersAll = await this.getListWithSummaryDetails();
    const teamMembers = teamMembersAll.filter((tm) => tm.FullName.trim());
    var actives = teamMembers.filter((c) => c.HasActiveCommitment) as TeamMemberSummarySort[];
    var inactives = teamMembers.filter((c) => !c.HasActiveCommitment) as TeamMemberSummarySort[];
    if (inactives && inactives.length > 0) {
      inactives[0].isFirstInactive = true;
    }
    teammemberSortList.push(...actives);
    teammemberSortList.push(...inactives);
    return teammemberSortList;
  }

  // Todo: should move to azure function
  public static getTeamMembersOfCustomer(customerId: string): Promise<Array<{ id: string; Name: string }>> {
    return new Promise((resolve, reject) => {
      firestore
        .collection(CollectionsNames.Commitment)
        .where(Fields.Commitments.CustomerIds, "array-contains", customerId)
        .get()
        .then((commitmentResult: any) => {
          if (commitmentResult.empty) {
            resolve([]);
          } else {
            const retVal = [] as Array<{ id: string; Name: string }>;
            commitmentResult.docs
              .map((d: any) => {
                const commitment = { id: d.id, ...d.data() } as Commitment;
                return commitment.TeamMembers;
              })
              .forEach((tms: any) => {
                tms.forEach((tm: any) => {
                  if (retVal.filter((x) => x.id === tm.id).length === 0) {
                    retVal.push({ id: tm.id, Name: tm.TmFullName });
                  }
                });
              });
            resolve(retVal);
          }
        })
        .catch((commitmentError: any) => reject("commitmentError => " + commitmentError));
    });
  }

  public static async setCertificate(model: Certificate, teammemberId = ""): Promise<Certificate> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/saveCertificate${query.param}`, model)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve({} as Certificate);
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  private static getParams(teammemberId = "") {
    var path = "";
    var param = "";
    if (teammemberId) {
      param = `/${teammemberId}`;
      path = "/admin";
    }
    return { param, path };
  }

  public static async setLanguageSkill(model: LanguageSkill, teammemberId = ""): Promise<LanguageSkill[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/saveLanguageSkill${query.param}`, model)
        .then((res) => {
          if (!res.data) {
            resolve([] as LanguageSkill[]);
          } else {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getLanguageSkills(teammemberId = ""): Promise<LanguageSkill[] | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/languageSkills${query.param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            resolve(res.data.value as LanguageSkill[]);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  private static convertResponse(result: any) {
    if (result && result.length > 0) {
      result.forEach((c: any) => {
        if (c) {
          if (c.StartTimerDate) {
            c.StartTimerDate = new Date(c.StartTimerDate);
          }
          if (c.EndTimerDate) {
            c.EndTimerDate = new Date(c.EndTimerDate);
          }
          if (c.VerifiedOn) {
            c.VerifiedOn = new Date(c.VerifiedOn);
          }
        }
      });
      return result;
    }
  }

  private static getContactResponse(res: any) {
    if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
      return [];
    } else {
      res.data.value.Addresses = this.convertResponse(res.data.value.Addresses);
      res.data.value.PhoneNumbers = this.convertResponse(res.data.value.PhoneNumbers);
      return res.data.value;
    }
  }

  public static getContact(teammemberId = ""): Promise<Contact | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/contact${query.param}`, "")
        .then((res) => {
          resolve(this.getContactResponse(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getExperienceDetail(teammemberId = ""): Promise<ProfessionalDetail | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/experienceDetail${query.param}`, "")
        .then((res: any) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            resolve(res.data.value as ProfessionalDetail);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getEducations(teammemberId = ""): Promise<Education[] | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/educations${query.param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            var response = res.data.value;
            response.forEach((item: any) => {
              if (item.StartDate) {
                item.StartDate = new Date(item.StartDate);
              }
              if (item.EndDate) {
                item.EndDate = new Date(item.EndDate);
              }
            });
            resolve(response as Education[]);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  private static getDataFromResponse(list: any) {
    const retVal = list.map((doc: any) => {
      const item = { id: doc.Id, ...doc };
      if (item.EndDate && doc.EndDate) {
        item.EndDate = new Date(doc.EndDate);
        item.EndDate = Utils.removeTimezoneOffset(item.EndDate);
      }
      if (item.StartDate) {
        item.StartDate = new Date(doc.StartDate);
        item.StartDate = Utils.removeTimezoneOffset(item.StartDate);
      }
      return item;
    });

    return retVal;
  }

  public static async setEducation(model: Education, teammemberId = ""): Promise<Education[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      var startDate = Utils.addTimezoneOffsetToStartDate(model.StartDate);
      var endDate = Utils.addTimezoneOffsetToEndDate(model.EndDate);

      if (startDate) {
        model.StartDate = startDate;
      }
      if (endDate) {
        model.EndDate = endDate;
      }
      ApiService.post(`${query.path}/teammember/saveEducation${query.param}`, model)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve([] as Education[]);
          } else {
            var retval = this.getDataFromResponse(res.data.value) as Education[];
            resolve(retval);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async deleteEducation(id: any, teammemberId = ""): Promise<Education[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.delete(`${query.path}/teammember/removeEducation/${id}${query.param}`)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve([] as Education[]);
          } else {
            var retval = this.getDataFromResponse(res.data.value) as Education[];
            resolve(retval);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getCertificates(teammemberId = ""): Promise<Certificate[] | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/certificates${query.param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            resolve(res.data.value as Certificate[]);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  private static getVerificationResponseList(res: any) {
    if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
      return [];
    } else {
      var result = this.convertResponse(res.data.value);
      return result;
    }
  }

  public static verifyPhone(phone: Phone, teammemberId = ""): Promise<Phone[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      var verificationCode = phone.VerificationCode;
      ApiService.post(`${query.path}/teammember/verifyPhone/${phone.Id}${query.param}`, { verificationCode })
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static verifyAddress(address: any, teammemberId = ""): Promise<Address[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      var verificationCode = address.VerificationCode;
      ApiService.post(`${query.path}/teammember/verifyAddress/${address.Id}${query.param}`, { verificationCode })
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static sendAddressCode(id: any, teammemberId = ""): Promise<Address[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/sendAddressVerificationCode/${id}${query.param}`, null)
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static sendPhoneCode(id: any, teammemberId = ""): Promise<Phone[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/sendPhoneVerificationCode/${id}${query.param}`, null)
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static setAddressAsDefault(addressId: any, teammemberId = ""): Promise<Address[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/address/setAsDefault/${addressId}${query.param}`, null)
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static setPhoneAsDefault(phoneId: any, teammemberId = ""): Promise<Phone[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/phone/setAsDefault/${phoneId}${query.param}`, null)
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static removeAddress(addressId: any, teammemberId = ""): Promise<Address[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.delete(`${query.path}/teammember/address/${addressId}${query.param}`) //check later
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static removePhone(phoneId: any, teammemberId = ""): Promise<Phone[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.delete(`${query.path}/teammember/phone/${phoneId}${query.param}`)
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static savePhone(phone: any, teammemberId = ""): Promise<Phone[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/phone${query.param}`, phone)
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static saveRoleAndTitle(details: any, teammemberEmail = ""): Promise<string> {
    return new Promise((resolve, reject) => {
      var path = "";
      var param = "";
      if (teammemberEmail) {
        param = `/${teammemberEmail}`;
        path = "/admin";
      }
      ApiService.post(`${path}/teammember/roleAndTitle${param}`, details)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static saveAddress(address: any, teammemberId = ""): Promise<Address[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/address${query.param}`, address)
        .then((res) => {
          resolve(this.getVerificationResponseList(res));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getSkillDownloadLink(skillId: any, teammemberId = ""): Promise<any> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/downloadSkillCv/${skillId}${query.param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static uploadSkillCv(skillId: any, file: File, teammemberId = ""): Promise<string> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.upload(`${query.path}/teammember/uploadSkillCv/${skillId}${query.param}`, file)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  private static getTeammemberResponse(result: any) {
    var item = { ...result } as Teammember;
    item.BirthDate = new Date(result.BirthDate);
    item.BirthDate = Utils.removeTimezoneOffset(item.BirthDate);
    if (item.UpdatedPaymentMethodDate) {
      item.UpdatedPaymentMethodDate = new Date(result.UpdatedPaymentMethodDate);
      item.UpdatedPaymentMethodDate = Utils.removeTimezoneOffset(item.UpdatedPaymentMethodDate);
    }
    item.Educations?.forEach((item) => {
      if (item.StartDate) {
        item.StartDate = new Date(item.StartDate);
      }
      if (item.EndDate) {
        item.EndDate = new Date(item.EndDate);
      }
    });
    return { ...result } as Teammember;
  }
  public static getPersonalDetail(teammemberId = ""): Promise<Teammember | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/personalDetails${query.param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            var model = this.getTeammemberResponse(res.data.value);
            resolve(model);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static removeSkill(skillId: any, teammemberId = ""): Promise<TeammemberSkill[]> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/removeSkill/${skillId}${query.param}`, "")
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve([]);
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static updateSkill(skillModel: any, teammemberEmail = ""): Promise<TeammemberSkill[]> {
    return new Promise((resolve, reject) => {
      var path = "";
      var param = "";
      if (teammemberEmail) {
        param = `/${teammemberEmail}`;
        path = "/admin";
      }
      ApiService.post(`${path}/teammember/saveSkill${param}`, skillModel)
        .then((res) => {
          if (!res.data) {
            resolve([]);
          } else {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static saveExperienceJobPreferences(model: JobPreferencesModel, teammemberId = ""): Promise<JobPreferencesModel | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/jobPreferences${query.param}`, model)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err.data);
        });
    });
  }

  public static removeExperienceJobPreferences(id: string, teammemberId = ""): Promise<string | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.delete(`${query.path}/teammember/jobPreferences/${id}${query.param}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }

  public static saveExperienceDetail(model: ProfessionalDetail, teammemberId = ""): Promise<ProfessionalDetail | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/experienceDetail${query.param}`, model)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static savePersonalDetail(model: PersonalDetailModel, teammemberId = ""): Promise<PersonalDetailModel | null> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/personalDetail${query.param}`, model)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve(null);
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async verifyCaptcha(captchaToken: any, teammemberId = ""): Promise<RecaptchaResponse> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.post(`${query.path}/teammember/verifyCaptcha${query.param}`, { captchaToken: captchaToken })
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve({} as RecaptchaResponse);
          } else {
            const result = { ...res.data.value } as RecaptchaResponse;
            resolve(result);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static uploadCertificateCv(certificateId: any, file: File, teammemberId = ""): Promise<string> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.upload(`${query.path}/teammember/uploadCertificateCv/${certificateId}${query.param}`, file)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static getCertificateDownloadLink(certificateId: any, teammemberId = ""): Promise<any> {
    return new Promise((resolve, reject) => {
      var query = this.getParams(teammemberId);
      ApiService.get(`${query.path}/teammember/downloadCertificateCv/${certificateId}${query.param}`)
        .then((res) => {
          if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
            resolve("");
          } else {
            resolve(res.data.value);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // public static getCareerHistories(teammemberId = ""): Promise<CareerHistories[] | null> {
  //   return new Promise((resolve, reject) => {
  //     var path = "";
  //     var param = ""
  //     if (teammemberId) {
  //       param = `/${teammemberId}`;
  //       path = "/admin";
  //     }
  //     ApiService.get(`${path}/teammember/careerHistories${param}`, '')
  //       .then((res) => {
  //         if (!res.data || res.data.statusCode != SystemErrors.Authentication.Success || !res.data.value) {
  //           resolve(null);
  //         } else {
  //           resolve(res.data.value as CareerHistories[]);
  //         }
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }
}
